import axios from "axios";
import Cookies from "js-cookie";
import { baseURL } from "../../js/helpers/baseURL";
import { saveUserBootstrap } from "../../js/helpers/userBootstrap";

const getUser = (data) => ({
    type: "GET_USER",
    payload: data,
});

let lastFetch = 0;

/** Lightweight user fetch for marketing pages — avoids the full app actions tree. */
export function fetchLandingUser() {
    return (dispatch) => {
        const token = Cookies.get("access_token");
        if (!token) return;

        const now = Date.now();
        if (now - lastFetch < 1000) return;
        lastFetch = now;

        const tz = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
        axios
            .get(`${baseURL}user?timezone=${tz}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                const payload = response.data?.data ?? response.data ?? response;
                saveUserBootstrap(payload);
                dispatch(getUser(payload));
            })
            .catch(() => {});
    };
}
